import React from "react";
import Presentation from "./mainbody/Presentation";
import Projects from "./mainbody/Projects";
import Aboutme from "./mainbody/Aboutme";
import Contactme from "./mainbody/Contactme";
import Blog from "./mainbody/Blog";
import Skill from "./mainbody/Skill";

function Mainbody() {
  return (
    <div>
      <Presentation />
      <Skill />
      <Projects />
      <Blog />
      <Aboutme />
      <Contactme />

      <br />
      <br />
      <br />
    </div>
  );
}

export default Mainbody;
